import type { Location } from '@/types/doctor-v2';

const EMAIL_ADDRESS_PATTERN = /\b[^\s@]+@[^\s@]+\.[^\s@]+\b/gi;

export const withoutEmailAddresses = (text: string) =>
  text
    .split('\n')
    .map((line) => line.replace(EMAIL_ADDRESS_PATTERN, '').trim())
    .filter(Boolean)
    .join('\n');

export const withoutEmailAddressesInLocation = (
  location: Location,
): Location => ({
  ...location,
  description: withoutEmailAddresses(location.description),
});
